import { render } from "./LogRegMain.vue?vue&type=template&id=2686c8e4&scoped=true"
import script from "./LogRegMain.vue?vue&type=script&lang=js"
export * from "./LogRegMain.vue?vue&type=script&lang=js"

import "./LogRegMain.vue?vue&type=style&index=0&id=2686c8e4&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2686c8e4"]])

export default __exports__